/* eslint-disable camelcase */
import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { addTerm, AddTermApiParameters } from "@tKgpco/Services/TermsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { QuoteTerms } from "@tKgpco/Store/Data/Terms/TermsState";

type Parameters = AddTermApiParameters & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, QuoteTerms>;

export const PopulateApiParameters: HandlerType = props => {
    const { TermsCode, Vendor, Estimate, Description, Default, Type } = props.parameter;
    props.apiParameter = {
        TermsCode,
        Vendor,
        Type,
        Estimate,
        Description,
        Default
    };
};

export const CreateTerm: HandlerType = async props => {
    try {
        await addTerm(props.parameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameters, CreateTerm, ExecuteOnSuccess];

const addNewTerm = createHandlerChainRunner(chain, "AddNewTerm");
export default addNewTerm;
